export default __webpack_public_path__ + "static/media/photo2.5df03892.jpg";